import React from "react";

const YTIcon = () => {
	return (
		<svg
			width='36'
			height='37'
			viewBox='0 0 36 37'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_42_31)'>
				<path
					d='M0 18.5C0 8.5589 8.0589 0.5 18 0.5C27.9411 0.5 36 8.5589 36 18.5C36 28.4411 27.9411 36.5 18 36.5C8.0589 36.5 0 28.4411 0 18.5Z'
					fill='#FF0000'
				/>
				<path
					d='M27.1988 14.0548C26.978 13.2066 26.3273 12.5386 25.5012 12.3119C24.0041 11.8999 18 11.8999 18 11.8999C18 11.8999 11.996 11.8999 10.4987 12.3119C9.67255 12.5386 9.02192 13.2066 8.80112 14.0548C8.40002 15.5922 8.40002 18.7999 8.40002 18.7999C8.40002 18.7999 8.40002 22.0075 8.80112 23.545C9.02192 24.3933 9.67255 25.0612 10.4987 25.288C11.996 25.6999 18 25.6999 18 25.6999C18 25.6999 24.0041 25.6999 25.5012 25.288C26.3273 25.0612 26.978 24.3933 27.1988 23.545C27.6 22.0075 27.6 18.7999 27.6 18.7999C27.6 18.7999 27.6 15.5922 27.1988 14.0548Z'
					fill='white'
				/>
				<path
					d='M16.2 22.1001V16.1001L21 19.1002L16.2 22.1001Z'
					fill='#FF0000'
				/>
			</g>
			<defs>
				<clipPath id='clip0_42_31'>
					<rect
						width='36'
						height='36'
						fill='white'
						transform='translate(0 0.5)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default YTIcon;
